<template>
  <v-container class="facts mt-6">
    <top-list-users/>
  </v-container>
</template>
<script>
import TopListUsers from './../components/facts/TopListUsers'

export default {
  components: {TopListUsers}
}
</script>
<style lang="scss">
  .facts {
    padding-bottom: 80px;
  }
</style>
